/** Контент лендинга `/use-cases/timer-event-production` (вёрстка — `UseCasePageLayout`). */

import type { UseCasePageContent } from './useCasePageContent';

export const PRODUCTION_TIMING_CONTENT: UseCasePageContent = {
  heroEyebrow: 'ШОУ, ТРАНСЛЯЦИИ, НЕСКОЛЬКО СЦЕН',
  heroLead:
    'Облачный таймер для продюсеров и продакшн-команд. Соберите программу из нескольких таймеров и сообщений для спикера — всё работает в браузере, без установки.',
  heroNote: 'Бесплатно, без регистрации. Работает в браузере.',

  scenarios: {
    title: 'Где пригодится',
    lead:
      'preztimer помогает держать тайминг, когда команда работает с разных точек площадки, а счёт идёт на секунды.',
    items: [
      {
        title: 'Живые шоу и сцена',
        text: 'Оператор ведёт очередь таймеров, спикер видит крупный отсчёт и подсказки на экране у сцены.',
      },
      {
        title: 'Трансляции и эфир',
        text: 'Режиссёр и ведущий смотрят на одно время; перерасход блока виден сразу в формате +00:01.',
      },
      {
        title: 'Несколько залов и треков',
        text: 'Отдельная комната на каждую сцену — программа каждого зала идёт независимо.',
      },
    ],
  },

  share: {
    title: 'Просто запустить и легко поделиться',
    paragraphs: [
      'preztimer — таймер с удалённым управлением: запуск, пауза и сброс с любого устройства в браузере. Экран таймера и панель управления открываются по ссылке.',
      'Спикеру и в зал отправьте экран таймера, команде — панель управления. Установка и регистрация не нужны: можно начать с гостевой комнаты.',
    ],
  },

  cloud: {
    title: 'Ведите тайминг продакшна в облаке',
    lead: 'Подходит операторам и продакшн-командам: не нужны кабели между экранами по площадке.',
    bullets: [
      'любое устройство с интернетом — ноутбук, планшет, телефон;',
      'всё работает в браузере, без установки;',
      'не нужны HDMI- или SDI-разветвители.',
    ],
  },

  communication: {
    title: 'Тайминг и связь без лишнего',
    lead:
      'Соберите программу из готовых таймеров и сообщений. Без бумажных табличек и беготни к ноутбуку, чтобы перезапустить отсчёт.',
    bullets: [
      'управляйте таймерами удалённо;',
      'делитесь таймером по ссылке или QR-коду;',
      'показывайте спикеру сообщения и предупреждения.',
    ],
  },

  modes: {
    title: 'Для офлайн-событий и любых режимов',
    lead: 'Включите нужный режим в один клик — для площадки и онлайна.',
    bullets: [
      'обратный отсчёт, секундомер или часы (время суток);',
      'последовательность таймеров с плановым временем старта слотов;',
      'пауза, переключение и корректировка времени вручную — контроль остаётся у оператора.',
    ],
  },

  pricing: {
    title: 'Цены',
    lead:
      'Базовые функции тайминга — бесплатно. Профи добавляет команду, больше таймеров и подключений.',
  },

  crossLink: {
    title: 'Связанный сценарий: программа дня и несколько спикеров',
    lead:
      'Конференция с секциями, передачами между слотами и залом — отдельная страница с акцентом на программу всего дня.',
    to: '/use-cases/conferences',
    linkLabel: 'Таймер для конференций',
  },

  faqSectionTitle: 'Частые вопросы о таймере для продакшн-команд',
  faqItems: [
    {
      question: 'Чем это лучше десктопного таймера или железа?',
      answer:
        'Экран таймера работает в браузере и открывается по ссылке на любом устройстве. Не нужны HDMI/SDI-разветвители и отдельная установка на ПК — монитор в зале и ноутбук оператора получают одно и то же время.',
    },
    {
      question: 'Можно ли запрограммировать автопереходы между таймерами?',
      answer:
        'Нет. В текущей версии автопереходов нет: запуск, пауза и переход к следующему таймеру выполняются вручную. Во время работы можно добавить или убавить время быстрыми кнопками. Для слотов можно задать плановое время старта, оно видно на панели управления.',
    },
    {
      question: 'Сколько человек могут вести тайминг одновременно?',
      answer:
        'Ссылку на панель управления можно открыть на нескольких устройствах — режиссёр и оператор работают с одним состоянием комнаты. Число одновременных подключений: на Базовом — 3, на Профи — 5 по умолчанию (до 25). На Профи доступны приглашения в команду.',
    },
    {
      question: 'Можно ли вести несколько сцен или залов сразу?',
      answer:
        'Да: создайте отдельную комнату на каждую сцену или трек. На Базовом — до трёх комнат на аккаунт, на Профи — без лимита.',
    },
    {
      question: 'Какие режимы таймера доступны?',
      answer:
        'Обратный отсчёт, секундомер и режим часов (текущее время суток). Для обратного отсчёта можно включить показ перерасхода после нуля.',
    },
    {
      question: 'Что будет при перезагрузке или потере связи?',
      answer:
        'Состояние комнаты хранится в облаке: таймеры, активный блок и сообщения восстанавливаются после обновления вкладки. Для синхронизации нужен интернет.',
    },
  ],
};
